@for (flag of flags(); track flag) {
  <div class="wrapper-flag">
    {{ flag }}
    <mat-slide-toggle [checked]="getFlagValue(flag)" (change)="setFlag(flag,$event.checked)"></mat-slide-toggle>
  </div>
}
